export const minValueFreeShip = 500
export const shippingFeeStandard = 90
export const fb_url = 'https://www.facebook.com/profile.php?id=100067691958117'
export const instagram_url = 'https://www.instagram.com/airabica/'
export const youTubeChannel_url = 'https://www.youtube.com/channel/UC7IHPiy483lXs1FGFi7HQ8w'
// export const twitter_url = ''

export const portfolio1 = [
    {
        id: 1,
        class: 'accessories women',
        image: './images/portfolio/item-1.jpg',
        category: 'Accessories'
    },
    {
        id: 2,
        class: 'men',
        image: './images/portfolio/item-2.jpg',
        category: 'Men'
    },
    {
        id: 3,
        class: 'women accessories',
        image: './images/portfolio/item-3.jpg',
        category: 'Women'
    },
    {
        id: 4,
        class: 'men',
        image: './images/portfolio/item-4.jpg',
        category: 'Accessories'
    },
    {
        id: 5,
        class: 'men women',
        image: './images/portfolio/item-5.jpg',
        category: 'Women'
    },
    {
        id: 6,
        class: 'men accessories',
        image: './images/portfolio/item-6.jpg',
        category: 'Men'
    }
]

export const shopData = {
    "sizes": [
        // {
        //     size: 'Extra Small',
        //     slug: 'XS'
        // },
        // {
        //     size: 'Small',
        //     slug: 'S'
        // },
        // {
        //     size: 'Medium',
        //     slug: 'M'
        // },
        // {
        //     size: 'Large',
        //     slug: 'L'
        // },
        // {
        //     size: 'Extra Large',
        //     slug: 'XL'
        // }
        {
            size: '250g',
            slug: '250g'
        },
        {
            size: '500g',
            slug: '500g'
        },
        {
            size: '1kg',
            slug: '1kg'
        }
    ],

    "origin": [        
        {
            origin: 'Brazil',
            slug: 'BR'
        },
        {
            origin: 'Columbia',
            slug: 'COL'
        },
        {
            origin: 'Costa Rica',
            slug: 'CR'
        },
        {
            origin: 'Ethiopia',
            slug: 'ETH'
        },
        {
            origin: 'Guatemala',
            slug: 'GTM'
        },
        {
            origin: 'Honduras',
            slug: 'HND'
        },
        {
            origin: 'Kenya',
            slug: 'KEN'
        },
        {
            origin: 'Nicaragua',
            slug: 'NIC'
        },
        {
            origin: 'Tanzania',
            slug: 'TZ'
        },
        {
            origin: 'South Africa',
            slug: 'ZA'
        },
        {
            origin: 'Various',
            slug: 'various'
        }
    ],

    "colors": [
        {
            color: '#cc9966',
            color_name: 'Brown'
        },
        {
            color: '#3399cc',
            color_name: 'Blue'
        },
        {
            color: '#9966cc',
            color_name: 'Purple'
        },
        {
            color: '#333333',
            color_name: 'Black'
        },
        {
            color: '#669933',
            color_name: 'Green'
        },
        {
            color: '#cc3333',
            color_name: 'Red'
        },
        {
            color: '#999999',
            color_name: 'Grey'
        }
    ],

    "brands": [
        {
            brand: "AeroPress",
            slug: "aeropress"
        },
        {
            brand: "Airabica",
            slug: "airabica"
        },
        {
            brand: "Air-Motion",
            slug: "air-motion"
        },
        {
            brand: "Airscap",
            slug: "airscape"
        },
        {
            brand: "Brutrek",
            slug: "brutrek"
        },
        {
            brand: "Bialetti",
            slug: "bialetti"
        },
        {
            brand: "Eversys",
            slug: "eversys"
        },
        {
            brand: "Espazzola",
            slug: "espazzola"
        },
        {
            brand: "Henlo",
            slug: "henlo"
        },
        {
            brand: "Idroprep",
            slug: "idroprep"
        },
        {
            brand: "redespresso",
            slug: "redespresso"
        },
        {
            brand: "1Zpresso",
            slug: "1zpresso"
        }
    ],

    "categories": [
        {
            name: "Accessories",
            slug: "accessories",
            count: 2
        },
        {
            name: "Brewing",
            slug: "brewing",
            count: 8
        },
        {
            name: "Coffee",
            slug: "coffee",
            count: 1
        },
        {
            name: "Cleaning",
            slug: "cleaning",
            count: 5
        },
        {
            name: "Drinkware",
            slug: "drinkware",
            count: 5
        },
        {
            name: "Grider",
            slug: "grinder",
            count: 8
        },
        {
            name: "Hot Chocolate",
            slug: "hotchocolate",
            count: 8
        },
        {
            name: "Rooibos Tea",
            slug: "rooibostea",
            count: 8
        },
        {
            name: "Storage",
            slug: "storage",
            count: 3
        },
        {
            name: "Roaster",
            slug: "roaster",
            count: 8
        },
    ],

    "prices": [
        {
            min: '0',
            max: '25',
            name: 'Under R25'
        },
        {
            min: '25',
            max: '50',
            name: 'R25 to R50'
        },
        {
            min: '50',
            max: '100',
            name: 'R50 to R100'
        },
        {
            min: '100',
            max: '200',
            name: 'R100 to R200'
        },
        {
            min: '200',
            max: null,
            name: 'R200 & Above'
        },
    ]
}

export const homeData = {
    brands: [
        {
            "name": "brand",
            "image": "./images/brands/1.png",
            "width": 100,
            "height": 23
        },
        {
            "name": "brand",
            "image": "./images/brands/2.png",
            "width": 101,
            "height": 34
        },
        {
            "name": "brand",
            "image": "./images/brands/3.png",
            "width": 100,
            "height": 30
        },
        {
            "name": "brand",
            "image": "./images/brands/4.png",
            "width": 101,
            "height": 39
        },
        {
            "name": "brand",
            "image": "./images/brands/5.png",
            "width": 100,
            "height": 48
        },
        {
            "name": "brand",
            "image": "./images/brands/6.png",
            "width": 100,
            "height": 23
        },
        {
            "name": "brand",
            "image": "./images/brands/7.png",
            "width": 63,
            "height": 32
        },
        {
            "name": "brand",
            "image": "./images/brands/8.png",
            "width": 80,
            "height": 72
        },
        {
            "name": "brand",
            "image": "./images/brands/9.png",
            "width": 100,
            "height": 25
        }
    ]
}